import * as Sentry from "@sentry/nextjs";

import { captureClientError } from "./clientLogs";

/**
 * Report a fatal, otherwise-unobservable client error to both Sentry and
 * PostHog (see components/ErrorBoundary.jsx and pages/_error.js — the two
 * top-level error surfaces this app has, both funneling through here so
 * alerting/filtering on `component`/level behaves the same from either one).
 * @param {unknown} error
 * @param {Object} [options]
 * @param {string} options.component - Sentry tag identifying which surface caught this
 * @param {Object} [options.clientLogExtra] - extra properties for captureClientError
 */
export const reportFatalError = (error, { component, clientLogExtra = {} } = {}) => {
  Sentry.withScope((scope) => {
    scope.setLevel("fatal");
    if (component) scope.setTag("component", component);
    Sentry.captureException(error);
  });

  // PostHog too, because Sentry is going and this is the only record these
  // surfaces leave anywhere once it's gone.
  captureClientError(error, clientLogExtra);
};
